import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateACSplitType } from '../../redux/ac_split_type/ac_split_type_actions';

const mapStateToProps = state => ({
  isDuplicating: state.ac.splitType.isDuplicating,
  errorMessage: state.ac.splitType.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateACSplitType(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/ACSplitTypeDuplicateModal.js